import apiClient from './apiConfig';

export const postsApi = {
  // Get all posts with optional query parameters
  getAllPosts: async (query = '') => {
    try {
      const response = await apiClient.get(`/posts${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single post by ID
  getPostById: async (postId) => {
    try {
      const response = await apiClient.get(`/posts/${postId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new post
  createPost: async (postData) => {
    try {
      const response = await apiClient.post('/posts', postData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy username/password đăng nhập acc — route riêng, không đi kèm response
  // GET /posts hay GET /posts/:id (ẩn khỏi API công khai).
  getCredentials: async (postId) => {
    try {
      const response = await apiClient.get(`/posts/${postId}/creds`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lịch sử đổi user/pass đăng nhập acc (mới nhất trước) — để lần lại khi sửa
  // nhầm. Route riêng như /creds, không đi kèm GET /posts hay GET /posts/:id.
  getCredentialsHistory: async (postId) => {
    try {
      const response = await apiClient.get(`/posts/${postId}/creds-history`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update post
  updatePost: async (postId, postData) => {
    try {
      const response = await apiClient.put(`/posts/${postId}`, postData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete post
  deletePost: async (postId, username) => {
    try {
      const response = await apiClient.delete(`/posts/${postId}`, {
        data: { username }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get posts by category
  getPostsByCategory: async (category) => {
    try {
      const response = await apiClient.get(`/posts?cat=${category}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check if title already exists (dùng trước khi upload ảnh)
  checkTitleExists: async (title) => {
    try {
      const response = await apiClient.get('/posts/check/title', { params: { title } });
      return response.data; // { exists: boolean, id?: string }
    } catch (error) {
      throw error;
    }
  },

  // Get posts by user
  getPostsByUser: async (username) => {
    try {
      const response = await apiClient.get(`/posts?user=${username}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
